import { render, staticRenderFns } from "./Pipelines.vue?vue&type=template&id=515c6bf2&scoped=true&"
import script from "./Pipelines.vue?vue&type=script&lang=js&"
export * from "./Pipelines.vue?vue&type=script&lang=js&"
import style0 from "./Pipelines.vue?vue&type=style&index=0&id=515c6bf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515c6bf2",
  null
  
)

export default component.exports